import PropTypes from 'prop-types'

const CardRatingBody = ({message}) => {
  const hasMessage = Boolean(message)

  return <div className="mt-CardRating-body">{hasMessage && <p className="mt-CardRating-message">{message}</p>}</div>
}

CardRatingBody.displayName = 'CardRatingBody'

CardRatingBody.propTypes = {
  message: PropTypes.string
}

export default CardRatingBody
